import { Link } from 'react-router-dom';
import MainPanel from '../../components/MainPanel/MainPanel';
import DefaultLayout from '../../layout/Layout';
import { Icon } from '@iconify/react';
import { useEffect, useRef, useState } from 'react';
import Modal from '../../components/Misc/Modal';
import TicketSearchModal from './ModalContents/SearchModal';
import { DataGrid } from '@mui/x-data-grid';
import { IconButton, Menu, MenuItem } from '@mui/material';
import TicketUpdateModal from './ModalContents/TicketUpdateModal';
import { MoreVert } from '@mui/icons-material';

const Tickets = () => {
  const columns = [
    {
      field: 'account_id',
      headerName: 'Account ID',
      sortable: false,
      width: 100,
      minWidth: 100,
    },
    {
      field: 'event_id',
      headerName: 'Event ID',
      sortable: false,
      width: 100,
      minWidth: 100,
    },
    {
      field: 'cost',
      headerName: 'Cost',
      sortable: false,
      width: 100,
      minWidth: 100,
    },
    {
      field: 'event.name',
      headerName: 'Event Name',
      sortable: false,
      width: 300,
      minWidth: 300,
      renderCell: (param) => {
        return param.row.event.name;
      },
    },
    {
      field: 'event.occurs_at',
      headerName: 'Event Date',
      sortable: true,
      width: 200,
      minWidth: 200,
      renderCell: (param) => {
        return new Date(param.row.event.occurs_at).toLocaleString();
      },
    },
    {
      field: 'section',
      headerName: 'Section',
      sortable: false,
      width: 70,
      minWidth: 70,
    },
    {
      field: 'row',
      headerName: 'Row',
      sortable: false,
      width: 50,
      minWidth: 50,
    },
    {
      field: 'seat',
      headerName: 'Seat',
      sortable: false,
      width: 50,
      minWidth: 50,
    },
    {
      field: 'event.venue_name',
      headerName: 'Venue',
      sortable: false,
      width: 200,
      minWidth: 200,
      renderCell: (param) => {
        return param.row.event.venue_name;
      },
    },
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      width: 100,
      minWidth: 100,
    },
    // {
    //   field: 'pos_ticket_id',
    //   headerName: 'POS Ticket ID',
    //   sortable: false,
    //   width: 100,
    //   minWidth: 100,
    // },
    {
      field: 'rotating',
      headerName: 'Rotating',
      sortable: false,
      width: 70,
      minWidth: 70,
    },

    {
      field: 'ticket_id',
      headerName: 'Ticket ID',
      sortable: false,
      width: 150,
      minWidth: 150,
    },
    {
      field: 'barcode',
      headerName: 'Barcode',
      sortable: false,
      width: 200,
      minWidth: 150,
    },
    {
      field: 'option',
      headerName: '',
      width: 70,
      sortable: false,
      renderCell: (param) => {
        return (
          <IconButton
            onClick={(e) => handleClick(e, param)}
            aria-controls="optionMenu"
            aria-haspopup="true"
          >
            <MoreVert className="text-white" />
          </IconButton>
        );
      },
      disableColumnMenu: true,
      disableColumnResize: true,
    },
  ];
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [show, setShow] = useState({
    search: false,
    update: false,
  });
  const [tickets, setTickets] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [ticketId, setTicketID] = useState();
  const [pos_ticket_id, setPOSTicketID] = useState('');
  const [sortModel, setSortModel] = useState([
    {
      field: 'event.occurs_at',
      sort: 'asc',
    },
  ]);
  const showModal = (key) => {
    setShow({ ...show, [key]: true });
  };
  const [formData, setData] = useState({
    limit: paginationModel.pageSize,
    page: paginationModel.page + 1,
  });

  const hideModal = (key) => {
    setShow({ ...show, [key]: false });
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };
  const handleClick = (event, param) => {
    setTicketID(param.id);
    setPOSTicketID(param.row.pos_ticket_id);
    setAnchorEl(event.currentTarget);
  };
  const handleOption = () => {
    setAnchorEl(null);
    showModal('update');
  };
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (!isInitialRender.current) {
      searchTicket();
    } else {
      isInitialRender.current = false;
    }
  }, [paginationModel]);

  const searchTicket = () => {
    const { pageSize, page } = paginationModel;
    // ipcRenderer.sendMessage('searchTickets', {
    //   ...formData,
    //   limit: pageSize,
    //   page: page + 1,
    // });
    hideModal('search');
  };

  // ipcRenderer.on('searchTickets:done', (data) => {
  //   ipcRenderer.sendMessage('setLoading', false);
  //   let { count, tickets } = data;
  //   setTickets(sortTickets(tickets));
  //   setTotalRows(count);
  // });
  // ipcRenderer.on('updateTicket:done', (data) => {
  //   let { ticketId, pos_ticket_id } = data;
  //   ipcRenderer.sendMessage('setLoading', false);
  //   // return updateTicketData(ticketId, pos_ticket_id);
  // });
  const updateTicketData = (ticketId, pos_ticket_id) => {
    // console.log('ticketId: ', ticketId, tickets);
    const index = tickets.findIndex((x) => {
      console.log(x.id);

      return x.id == ticketId;
    });
    const newTickets = [...tickets];
    newTickets[index].pos_ticket_id = pos_ticket_id;
    setTickets(newTickets);
  };
  const onPaginationModalChange = (e) => {
    setPaginationModel(e);
  };

  const onSortModelChange = (model) => {
    setSortModel(model);
    setTickets(sortTickets(tickets)); 
  };

  const sortTickets = (tickets) => {
    if (!sortModel || sortModel.length === 0) return tickets;

    const { field, sort } = sortModel[0] || {
      field: 'event.occurs_at',
      sort: 'asc',
    };
    const sorted = [...tickets];
    sorted.sort((a, b) => {
      a = new Date(a.event.occurs_at);
      b = new Date(b.event.occurs_at);

      return sort === 'desc' ? a - b : b - a;
    });

    return sorted;
  };

  const updateTicket = () => {
    // ipcRenderer.sendMessage('updateTicket', { ticketId, pos_ticket_id });
    hideModal('update');
  };
  return (
    <DefaultLayout isLogin={false}>
      <MainPanel>
        <div className="flex flex-col h-full">
          <div className="flex items-center">
            <p className="text-lg font-500 font-semibold text-white">Tickets</p>
            <Link
              to="#"
              onClick={() => showModal('search')}
              className="inline-flex items-center justify-center gap-2.5 rounded-full bg-black py-2 px-5 text-center font-medium text-white hover:bg-opacity-90 ml-auto"
            >
              <Icon icon="material-symbols:search" /> Search
            </Link>
          </div>
          <div
            style={{ height: 'calc(100vh - 200px)', width: '100%' }}
            className="mt-4"
          >
            <DataGrid
              columns={columns}
              rows={tickets}
              columnBufferPx={100}
              rowBufferPx={100}
              classes={{
                root: 'bg-boxdark border-boxdark-2',
              }}
              paginationMode="server"
              paginationModel={paginationModel}
              onPaginationModelChange={onPaginationModalChange}
              pagination
              sortModel={sortModel}
              onSortModelChange={onSortModelChange}
              rowCount={totalRows}
              sx={{
                color: 'white',
                '& .*-MuiDataGrid-columnHeaderRow': {
                  background: 'red',
                },
              }}
              checkboxSelection
              disableColumnSelector={true}
            />
          </div>
          <Menu
            id="optionMenu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem>
              <Link
                to={`#`}
                onClick={handleOption}
                className="inline-flex items-center justify-center text-center font-medium text-grey hover:bg-opacity-90"
              >
                Update Ticket
              </Link>
            </MenuItem>
          </Menu>

          <Modal show={show.search || show.update}>
            {show.search ? (
              <TicketSearchModal
                onChange={onChange}
                formData={formData}
                onSubmit={searchTicket}
                onCancel={() => hideModal('search')}
              />
            ) : (
              <TicketUpdateModal
                onCancel={() => hideModal('update')}
                onSubmit={updateTicket}
                onChange={(e) => setPOSTicketID(e.target.value)}
                pos_ticket_id={pos_ticket_id}
              />
            )}
          </Modal>
        </div>
      </MainPanel>
    </DefaultLayout>
  );
};
export default Tickets;
